import { Resource } from "react-admin";
import RolesIcon from "@material-ui/icons/Security";
import React, { useEffect } from "react";
import { POLICY_ROLE_MAPPINGS } from "../../common/rolesManagement";
import PermissionDenied from "../../components/PermissionDenied";

// Maschera migrata su Polar (Strangler Fig): la lista react-admin è sostituita
// da un semplice redirect a pagina intera. Nessun codice condiviso con l'app
// Polar — l'unico punto di contatto è questo window.location.
const RedirectToPolar = () => {
    useEffect(() => {
        window.location.href = "/polar/role-mappings";
    }, []);
    return <div style={{ padding: 24 }}>Reindirizzamento…</div>;
};

export default permissions => (
    <Resource
        name="role-mappings"
        icon={RolesIcon}
        list={
            permissions && permissions.includes(POLICY_ROLE_MAPPINGS.READ)
                ? RedirectToPolar
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/RoleMappings/index.js